import { DgMenuItem } from '../common/menu/types';

export const MENU_ITEMS: DgMenuItem[] = [
  {
    title: 'پروفایل و مشخصات',
    icon: 'icon-profile-circle',
    link: '/profile/profile',
    home: true,
  },
  {
    title: 'آموزش های من',
    icon: 'icon-book-1',
    link: '/education-user/education-list',
  },
  {
    title: 'دادخواست های من',
    icon: 'icon-note-21',
    link: '/petition-user/user-petition-list',
  },
  {
    title: 'قرارداد های من',
    icon: 'icon-document-text',
    link: '/contract-user/contract-main',
  },
  {
    title: 'شکوائیه‌های من',
    icon: 'icon-note-2',
    link: '/complaint-user/complaint-main-user',
  },
  {
    title: 'بسته‌های حقوقی من',
    icon: 'icon-gift',
    link: '/package-user/user-package-list',
  },
  {
    title: 'اوراق قضایی',
    icon: 'icon-receipt-edit',
    link: '/judicial-user/judicial-main',
    dontBeAdmin: true,
  },
  {
    title: 'مشاوره',
    icon: 'icon-lamp-charge',
    link: '/consultation-user/consultation-user',
  },
  {
    title: 'تیکت ها',
    icon: 'icon-ticket-2',
    link: '/user-tickets/user-ticket-list',
  },
  {
    title: 'اطلاع رسانی',
    icon: 'icon-volume-high',
    link: '/notifications/notification-list',
  },
  {
    title: 'گفتگو ها',
    icon: 'icon-messages',
    link: '/chat/chat-list/user',
  },
  {
    title: 'کیف پول',
    icon: 'icon-wallet',
    link: '/payment/payment-list',
  },
  {
    title: 'درخواست فاکتور رسمی',
    icon: 'icon-receipt-square',
    link: '/payment/legal-factor-list',
    permissions: ['legal_user'],
    dontBeAdmin: true,
  },
  // {
  //     title: ' مکالمات من',
  //     icon: 'fa-phone',
  //     link: '/chat/chat-list',
  // },
  {
    type: 'hr',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'کارشناس',
    type: 'label',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'مشاوره',
    icon: 'fal fa-balance-scale',
    link: '/consultation-lawyer/consultation-lawyer',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'دادخواست',
    icon: 'fal fa-ticket-alt',
    link: '/petition-lawyer/petition-lawyer-list',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'قرارداد',
    icon: 'fal fa-briefcase',
    link: '/contract-lawyer/contract-list',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'شکوائیه‌',
    icon: 'fal fa-briefcase',
    link: '/complaint-lawyer/complaint-list',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'اوراق قضایی',
    icon: 'fal fa-file-contract',
    link: '/judicial-lawyer/judicial-list',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    title: 'گفتگو ها',
    icon: 'fal fa-comments',
    link: '/chat/chat-list/lawyer',
    permissions: ['lawyer'],
    dontBeAdmin: true,
  },
  {
    type: 'hr',
    permissions: [
      'get_system_info',
      'consultation_choose_lawyer',
      'get_smart_contract',
      'get_user_info',
      'get_group',
      'get_article_article',
      'edit_learning_course',
      'add_lawyer',
      'edit_lawyer',
      'get_ticket',
      'see_all_consultation',
      'edit_petition',
      'edit_coupon',
      'edit_notification_template',
      'edit_config',
      'edit_category',
      'get_support_chat',
    ],
  },
  {
    title: 'مدیریت',
    type: 'label',
    permissions: [
      'get_smart_contract',
      'get_contract_expertise',
      'custom_contract_set_price',
      'edit_ready_contract',
      'get_smart_contract',
      'edit_smart_contract',
      'get_custom_contract',
      'edit_custom_contract',
      'get_system_info',
      'consultation_choose_lawyer',
      'get_user_info',
      'get_group',
      'get_article_article',
      'edit_learning_course',
      'add_lawyer',
      'edit_lawyer',
      'get_ticket',
      'see_all_consultation',
      'edit_petition',
      'edit_coupon',
      'edit_notification_template',
      'edit_config',
      'edit_category',
      'get_support_chat',
    ],
  },
  {
    title: 'مدیریت کاربران',
    icon: 'fal fa-users',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت کاربران',
        icon: 'fal fa-users',
        link: '/user-managment/user-list',
        permissions: [
          'get_user_info',
          'coworker_request_verification',
          'legal_user_request_verification',
        ],
      },
      {
        title: 'مدیریت کاربران حقوقی',
        icon: 'fal fa-building',
        link: '/user-managment/legal-user-list',
        permissions: ['get_company_info', 'edit_company_staff'],
      },
      {
        title: 'مدیریت مشتریان',
        icon: 'fal fa-people-arrows',
        link: '/customers-admin/list',
        permissions: [''],
      },
      {
        title: 'مدیریت کاربران دعوت شده',
        icon: 'fal fa-user-friends',
        link: '/manage-users/list',
        permissions: ['get_article_article'],
      },
      {
        title: 'مدیریت نقش ها',
        icon: 'fal fa-users-class',
        link: '/user-managment/group-list',
        permissions: ['get_group'],
      },
    ],
  },
  {
    title: 'گفتگو ها',
    icon: 'fal fa-comments',
    link: '/chat/chat-list/support',
    permissions: ['get_support_chat'],
  },
  {
    title: 'مدیریت کمپین',
    icon: 'fal fa-newspaper',
    link: '/campaign',
    permissions: ['campaign'],
  },
  {
    title: 'مدیریت مجله',
    icon: 'fal fa-newspaper',
    link: '/news/news-list',
    permissions: ['get_article_article'],
  },
  {
    title: 'مدیریت آموزش',
    icon: 'fal fa-book-open',
    link: '/education-admin/education-list',
    permissions: ['edit_learning_course'],
  },
  {
    title: 'مدیریت کارشناسان',
    icon: 'fal fa-users-cog',
    link: '/lawyer-managment',
    permissions: [
      'add_lawyer',
      'edit_lawyer',
      'edit_comment',
      'edit_recommended_comments',
      'edit_lawyer',
      'add_lawyer',
      'get_comment',
    ], // FIXME: check this page
  },
  {
    title: 'مدیریت تیکت ها',
    icon: 'fal fa-clipboard-check',
    link: '/admin-tickets/admin-ticket-list/me',
    permissions: ['get_ticket'],
  },
  {
    title: 'مدیریت اوراق قضایی',
    icon: 'fal fa-file-contract',
    link: '/judicial-admin/instance-judicial-main',
    permissions: ['get_bill', 'get_declaration', 'get-other-judicial-request'],
  },
  {
    title: 'مدیریت نظرات',
    link: '/settings/confirm-comments',
    icon: 'fal fa-comment',
    permissions: ['edit_comment'],
  },
  {
    title: 'لیست فیلم های ضبط شده',
    icon: 'fal fa-film-alt',
    link: '/settings/recorded-sessions',
    permissions: ['bbb_supporter'],
  },
  {
    title: 'بسته‌های حقوقی',
    icon: 'fal fa-hand-holding-box',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت بسته‌های حقوقی',
        link: '/package-admin/package-main',
        icon: 'fal fa-box-full',
        permissions: ['get_packge'],
      },
      {
        title: 'بسته‌های حقوقی خریداری شده',
        link: '/package-admin/instance-package',
        icon: 'fal fa-box-open',
        permissions: ['get_package'],
      },
    ],
  },
  {
    title: 'مدیریت مالی سامانه',
    icon: 'isax icon-money-4',
    permissions : ['*'],
    children: [
      {
        title: 'مدیریت پرداختی ها',
        icon: 'fal fa-credit-card',
        link: '/payment/admin-payment-list',
        permissions: ['get_payment'],
      },
      {
        title: 'مدیریت فاکتور رسمی',
        link: '/payment/admin-factor-list',
        icon: 'isax icon-receipt-discount',
        permissions: [''],
      },
      {
        title: 'مدیریت قیمت و تخفیف',
        icon: 'fal fa-barcode-read',
        link: '/settings/price-settings',
        permissions: [
          'edit_coupon',
          'get_coupon',
          'edit_coupon',
          'edit_config',
        ],
      },
    ],
  },
  {
    title: 'مشاوره',
    icon: 'isax icon-lamp-1',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت مشاوره ها',
        icon: 'fal fa-lightbulb-on',
        link: '/consultation-admin',
        permissions: [
          'see_all_consultation',
          'see_all_consultation',
          'consultation_choose_lawyer',
        ],
      },
      {
        title: 'مدیریت مشاوره‌های تلفنی',
        icon: 'fal fa-phone',
        link: '/voip',
        permissions: [
          'see_all_consultation',
          'see_all_consultation',
          'consultation_choose_lawyer',
        ],
      },
    ],
  },
  {
    title: 'دادخواست ها',
    icon: 'fal fa-ticket-alt',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت دادخواست ها',
        link: '/petition-admin/petition-main',
        icon: 'fal fa-list-alt',
        permissions: ['edit_petition', 'get_petition'],
      },
      {
        title: 'دادخواست های خریداری شده',
        link: '/petition-admin/instance-petition-main',
        icon: 'fal fa-clipboard-list-check',
        permissions: [
          'get_petition_ins',
          'get_ready_petition_instance',
          'get_custom_petition_instance',
        ],
      },
    ],
  },
  {
    title: 'قرارداد ها',
    icon: 'fal fa-briefcase',
    // link: '/contract-admin/contract-main',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت قرارداد ها',
        icon: 'fal fa-file-signature',
        link: '/contract-admin/contract-main',
        permissions: [
          'get_smart_contract',
          'get_contract_expertise',
          'custom_contract_set_price',
          'edit_ready_contract',
          'get_ready_contract',
          'get_smart_contract',
          'edit_smart_contract',
          'get_custom_contract',
          'edit_custom_contract',
        ],
      },
      {
        title: 'قرارداد های خریداری شده',
        icon: 'fal fa-file-contract',
        link: '/contract-admin/instance-contract-main',
        permissions: [
          'get_smart_contract_ins',
          'get_expertise_meeting',
          'get_contract_meeting',
          'get_ready_contract_instance',
          'get_custom_contract_instance',
        ],
      },
    ],
  },
  {
    title: 'شکوائیه‌ها',
    icon: 'fal fa-file',
    permissions: ['*'],
    children: [
      {
        title: 'مدیریت شکوائیه‌ها',
        icon: 'fal fa-file-signature',
        link: '/complaint-admin/complaint-main',
        permissions: [
          'custom_complaint_set_price',
          'edit_ready_complaint',
          'get_ready_complaint',
          'get_custom_complaint',
          'edit_custom_complaint',
        ],
      },
      {
        title: 'شکوائیه‌های خریداری شده',
        icon: 'fal fa-file-contract',
        link: '/complaint-admin/instance-complaint-main',
        permissions: [
          'get_smart_complaint_ins',
          'get_ready_complaint_instance',
          'get_custom_complaint_instance',
        ],
      },
    ],
  },
  {
    title: 'گزارش‌ها',
    icon: 'fal fa-chart-bar',
    permissions: ['*'],
    children: [
      {
        title: 'اطلاعات سیستم',
        icon: 'fal fa-exclamation',
        link: '/settings/system-info',
        permissions: ['get_system_info', 'clear_config_cache'],
      },
      {
        title: 'گزارش خطاهای سیستمی',
        icon: 'fal fa-exclamation-triangle',
        link: '/settings/errors-log',
        permissions: ['get_log'],
      },
    ],
  },
  {
    title: 'پیکربندی',
    icon: 'fal fa-wrench',
    permissions: ['*'],
    children: [
      {
        title: 'صفحه آموزش سامانه',
        icon: 'fal fa-chalkboard-teacher',
        permissions: ['site_management'],
        link: '/tutorial/tutorial-main',
      },
      {
        title: 'مدیریت اعلان های سیستمی',
        icon: 'fal fa-comment-exclamation',
        link: '/settings/system-notifications',
        permissions: [
          'edit_notification_template',
          'edit_config',
          'get_notification_template',
        ],
      },
      {
        title: 'مدیریت آپلود فایل',
        icon: 'fal fa-upload',
        link: '/settings/file-upload',
        permissions: ['edit_config', 'get_file_url'],
      },
      {
        title: 'مدیریت دسته بندی ها',
        icon: 'fal fa-folders',
        link: '/settings/category-list',
        permissions: ['edit_category'],
      },
      {
        title: 'مدیریت محصولات',
        icon: 'fal fa-dolly',
        link: '/settings/limits',
        permissions: ['edit_config'],
      },
      {
        title: 'بانک سوالات',
        icon: 'fal fa-question',
        link: '/settings/question-bank',
        permissions: ['edit_config', 'manage_question'],
      },
      {
        title: 'مدیریت تگ‌ها',
        icon: 'fal fa-hashtag',
        link: '/settings/tags-managment',
        permissions: ['edit_tag'],
      },
    ],
  },
  {
    type: 'hr',
    permissions: ['seo_management'],
  },
  {
    title: 'مدیریت سئو',
    type: 'label',
    permissions: ['seo_management'],
  },
  {
    title: 'صفحات استاتیک',
    icon: 'fal fa-file-contract',
    permissions: ['seo_management'],
    children: [
      {
        title: 'صفحات دسته بندی',
        icon: 'fal fa-file-alt',
        link: 'seo-managment/seo-list/search',
        permissions: ['seo_management'],
      },
      {
        title: 'سایر صفحات',
        icon: 'fal fa-file',
        link: 'seo-managment/seo-list/static',
        permissions: ['seo_management'],
      },
    ],
  },
  {
    title: 'صفحات داینامیک',
    icon: 'fal fa-file-alt',
    permissions: ['seo_management'],
    children: [
      {
        title: 'دادخواست ها',
        icon: 'fal fa-list-alt',
        link: 'seo-managment/seo-list/petition',
        permissions: ['seo_management'],
      },
      {
        title: 'قرارداد ها',
        icon: 'fal fa-file-contract',
        link: 'seo-managment/seo-list/contract',
        permissions: ['seo_management'],
      },
      {
        title: 'شکوائیه ها',
        icon: 'fal fa-file-signature',
        link: 'seo-managment/seo-list/complaint',
        permissions: ['seo_management'],
      },
      {
        title: 'آموزش ها',
        icon: 'fal fa-user-graduate',
        link: 'seo-managment/seo-list/course',
        permissions: ['seo_management'],
      },
      {
        title: 'مجلات',
        icon: 'fal fa-newspaper',
        link: 'seo-managment/seo-list/article',
        permissions: ['seo_management'],
      },
    ],
  },
  {
    title: 'مدیریت اسکیما',
    icon: 'fal fa-browser',
    link: 'seo-managment/schema-list',
    permissions: ['schema_management']
  }
];
